import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import { HR_EMPLOYEE_NOTIFICATIONS_READ_ALL } from '../employeeNotificationEndpoints'
import {
  EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from '../employeeNotificationQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export function markAllEmployeeNotificationsRead(): Promise<void> {
  return axiosInstance
    .put(HR_EMPLOYEE_NOTIFICATIONS_READ_ALL)
    .then(() => undefined)
}

export function useMarkAllEmployeeNotificationsReadMutation(
  options?: UseMutationOptions<void, AxiosCustomError, void>
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: markAllEmployeeNotificationsRead,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      })
    },
  })
}
